import { render, staticRenderFns } from "./accommodation.vue?vue&type=template&id=4d6b607d"
import script from "./accommodation.vue?vue&type=script&lang=js"
export * from "./accommodation.vue?vue&type=script&lang=js"
import style0 from "./accommodation.vue?vue&type=style&index=0&id=4d6b607d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports